<template>
  <div id="main-wrap">
    <WebTools />
    <!--web nav-->
    <CspaWebMenu />

    <div class="body-wrap">
      <div class="">
        <div class="block-title-wrap">
          <div class="block-title">{{columnName}}</div>
        </div>
        <div class="association-desc-wrap">
          <h3>{{name}}</h3>
          <div v-html="content" class="association-desc-content"></div>
        </div>
      </div>
    </div>
    
    <CspaWebFooter />
  </div>
</template>

<script>
import axios from "axios"
import WebTools from "@/components/WebTools.vue"
import CspaWebMenu from "@/components/CspaWebMenu.vue"
import CspaWebFooter from "@/components/CspaWebFooter.vue"
export default {
  name: 'Home',
  components: {
    WebTools,
    CspaWebMenu,
    CspaWebFooter
  },

  data() {
    return {
      website: 0,
      columnName: '组织机构',
      name: '',
      content: '',
    }
  },

  //页面加载完成执行
  mounted() {
    this.initPageData()

    this.initContent()
  },

  //页面方法
  methods: {
    //初始化页面数据
    initPageData() {
      let sid = parseInt(this.$route.query.sid)
      if(!isNaN(sid) && sid>1) {
        this.website = sid
      } else {
        this.website = 0
      }
    },

    //初始化页面新闻数据
    initContent() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/description/content-get",
        {site: vm.website, contentType: 3},
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      ).then(function(res) {
        let errorCode = parseInt(res.data.code)
        if(!isNaN(errorCode) && errorCode==0) {
          let gotted = res.data.data
          vm.name = gotted.name
          vm.content = gotted.content
          //console.log(gotted)
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //分页事件
    pageEvent(page) {
      this.page = page
      this.initColumnNews()
    },


  }

}
</script>
